module.exports = __webpack_public_path__ + "placeholder-lease-thumbnail-1D_gTKd.svg";